<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <infantil-table />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import InfantilTable from "./components/InfantilTable";
  
  export default {
    name: "Infantil",
    components: {
      InfantilTable,
    },
  };
  </script>
  